import axios from 'axios';
import { Message } from 'element-ui';
import { JSEncrypt } from 'jsencrypt';
import getApiConfig from './configHook';

// 定义axios实例获取config.json文件中的SAAS_API
const newAxios = axios.create({
  timeout: 5000, //设置超时
});

async function getBaseUrl() {
  const data = await getApiConfig();

  if (process.env.NODE_ENV === 'production') {
    return data.SAAS_API;
  } else {
    return data.LOCAL_SAAS_API;
  }
}

//定义一个新的Message方法，多传入一个offset参数
const $message = (options) => {
  return Message({
    ...options,
    offset: 80,
  });
};

/**
 * 项目使用的axios实例定义
 */
const instance = axios.create({
  // baseURL: "http://192.168.110.129:8031/sass-1.0/", //接口统一域名
  timeout: 5000, //设置超时
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

getBaseUrl().then((res) => {
  instance.defaults.baseURL = res;
});

// 请求拦截
instance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截
instance.interceptors.response.use(
  (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    if (response.data.code == 200) {
      return response;
    } else if (response.data.code == 400) {
      $message({
        type: 'error',
        message: '无权限',
      });
    } else if (response.data.code == 500) {
      $message({
        type: 'error',
        message: response.data.message,
      });
      alert();
    } else {
      $message({
        type: 'error',
        message: response.data.message,
      });
    }
  },
  // 服务器状态码不是2开头的的情况
  (error) => {
    console.log('request error:', error);
    if (error.response.status) {
      switch (error.response.status) {
        case 500:
          $message({
            type: 'error',
            message: '服务器内部错误',
          });
          break;
        case 404:
          $message({
            type: 'error',
            message: '资源未找到',
          });
          break;
        // 其他错误，直接抛出错误提示
        default:
          $message({
            type: 'error',
            message: error.message,
          });
      }
      return Promise.reject(error.response);
    }
  }
);
/**
 * 10位随机字符串
 *
 */
function generateRandomString(length) {
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var result = '';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
/**
 * JSEncrypt加密
 *
 */
function encrypt(data) {
  // 引入RSA算法加密
  var encrypt = new JSEncrypt();
  // 公钥
  var publicKey =
    'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBALGzYgTN+sR9jwbSAIcHvn5IEajtl960xzvKYFN3hHbqCiolQVbgcf4XT8a+XndP3QvK7Ax5VLWYpcIfFEqvgVcCAwEAAQ==';
  encrypt.setPublicKey(publicKey);
  var encrypted = encrypt.encrypt(data, publicKey); // 使用公钥加密数据
  return encrypted;
}
export default {
  /**
   * get请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求携带的参数]
   */
  get(url, params) {
    var timestamp = Date.now();
    var salt = generateRandomString(10);
    var signature = encrypt(timestamp + salt);
    return instance({
      url,
      method: 'get',
      params,
      // crossDomain: true,
      headers: {
        Signature: signature,
        RequestTime: timestamp,
        Salt: salt,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
      },
    });
  },
  /**
   * post请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求携带的参数]
   */
  post(url, params, type) {
    if (type == 'data') {
      return instance({
        url,
        method: 'post',
        data: params,
      });
    } else {
      return instance({
        url,
        method: 'post',
        params,
      });
    }
  },
  /**
   * put请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求携带的参数]
   */
  put(url, params) {
    return instance({
      url,
      method: 'put',
      data: params,
    });
  },
  /**
   * delete请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求携带的参数]
   */
  delete(url, params) {
    return instance({
      url,
      method: 'delete',
      params,
    });
  },
};



// WEBPACK FOOTER //
// ./src/utils/saasApi.js